import React, { FC, ReactElement } from 'react';

import classNames from 'classnames';

import styles from './divider.module.scss';

interface IDivider {
  vertical?: boolean;
  borderColor?: string;
}

const Divider: FC<IDivider> = (props): ReactElement => {
  const { vertical = false, borderColor = 'var(--sk-border-subtle)' } = props;
  const dividerClassNames = classNames(styles.divider, {
    [styles['divider--vertical']]: vertical,
  });
  const dividerStyles = {
    borderColor,
  };
  return <hr style={dividerStyles} className={dividerClassNames} />;
};

export { Divider };
